<div class="col-12 col-md-9 p-3 pb-0 fs-6">
  <div class="row">
    <div style="display:block">
      <app-basic-step-one></app-basic-step-one>
    </div>
  </div>

  <div class="row justify-content-end">
    <div class="col-auto">
      <button class="btn btn-primary text-uppercase mx-2 my-2" type="button" (click)="restData()">
        {{ 'Sellers.Products.clear' | translate }}
      </button>
      <button [disabled]="stepOne?.stepForm?.pristine ?? true" class="btn btn-primary text-uppercase mx-2 my-2" type="button"
        (click)="save()">
        {{ 'Sellers.Products.save' | translate }}
      </button>
    </div>
  </div>
</div>
